import { ShellLink } from "@/src/components";
import NextImage from "../../NextImage";
import { PortfolioManage } from "../../PortfolioManage";
import { cn } from "utils";

export interface ItemProps {
  name: string;
  symbol: string;
  logo: string;
  price: number | string;
  change: number | string;
  id: string;
  type: "crypto" | "stock";
}
// grid-cols-[minmax(0,752px)_minmax(0,352px)]
export const Item = (Props: Partial<ItemProps>) => {
  const { name, symbol, logo, price, change = 0, id, type } = Props;
  if (!name || !symbol || !id) {
    return (
      <div className="grid grid-rows-2 gap-2 grid-cols-[16px_32px_1fr] items-center">
        <div
          className={cn(
            "row-span-2 w-4 h-4 rounded-1 bg-background_white_overlay5",
          )}
        ></div>
        <div
          className={cn(
            "row-span-2 w-8 h-8 rounded-full bg-background_white_overlay5",
          )}
        ></div>
        <div
          className={cn(
            "bg-background_white_overlay5 h-3.5 w-27 rounded-1 mt-0.375",
          )}
        ></div>
        <div
          className={cn(
            "bg-background_white_overlay5 h-3.5 w-38.5 rounded-1 mb-0.375",
          )}
        ></div>
      </div>
    );
  }

  return (
    <ShellLink
      aria-label="Item"
      data-openreplay-label={`Link | ${`/${type}/${type === "crypto" ? id : symbol}`}`}
      id="lnk-item"
      href={`/${type}/${type === "crypto" ? id : symbol}`}
      className="grid gap-2 grid-cols-[16px_32px_1fr] items-center"
      prefetch={true}
    >
      <PortfolioManage id={id} type={type === "crypto" ? "TOKEN" : "STOCK"} />
      <NextImage
        src={logo}
        alt={symbol}
        width={32}
        height={32}
        className="rounded-full"
      />
      <div className="grid grid-cols-2 grid-rows-[fit-content_fit-content] grid-cols-[1fr_1fr]">
        <div className="body_medium_m text-content_primary">{symbol}</div>
        <div
          className="body_medium_m text-content_primary text-right"
          dangerouslySetInnerHTML={{ __html: `$${price}` }}
        />
        <div
          className={cn(
            "body_s text-content_secondary truncate relative",
            // "before:block before:w-fit before:h-fit before:absolute before:-top-70% before:left-0 before:px-2 before:py-1.5 before:rounded-1.5 before:border before:border-solid before:border-border_white_transparent20 before:bg-background_solid_secondary before:text-content_primary/60 before:opacity-0 before:scale-95 before:transition-all before:duration-200 before:ease-out before:pointer-events-none",
            // PC端hover效果
            // "hover:before:opacity-100 hover:before:scale-100 md:hover:before:content-[attr(data-content)]",
          )}
          data-content={name}
        >
          {name}
        </div>
        <div
          className={cn("body_medium_s text-right", {
            "text-content_accent1_primary": Number(change) > 0,
            "text-content_accent2_primary": Number(change) < 0,
            "text-content_primary": Number(change) === 0,
          })}
        >
          {Number(change) === 0 ? "0" : change}%
        </div>
      </div>
    </ShellLink>
  );
};
